import { makeStyles } from "@material-ui/core";
import * as React from "react";

import { StrengthTag } from "@/components/agent/PlannerTags";

const useStyles = makeStyles(() => ({
  // 呼び出し側が gap 無しの flex で並べているので、タグ側で間隔を持つ
  chip: { margin: "4px 8px 4px 0" },
}));

interface props {
  label: string;
}

/** 得意な領域のタグ。見た目はプランナー詳細と同じ StrengthTag（Trello #245） */
export const StyledChip: React.FC<props> = ({ label }) => {
  const classes = useStyles();
  return <StrengthTag label={label} className={classes.chip} />;
};
